import React from 'react';
import PropTypes from 'prop-types';
import ArrayHelper from 'foundation/array-helper';
import { getRoundById } from 'general/js/helpers';
import { liveHole, getHardestHole } from 'components/live-hole';
import { ScorePlayerCell } from 'components/scores';
import { getPreviousRoundsIds } from './enums';
import {IS_HOLECARD_AVAILABLE} from 'general/js/constants';

class LivePlayerLocation extends React.Component {
    getHole() {
        const { holeId, scoringCourse } = this.props;

        if (!scoringCourse || !Array.isArray(scoringCourse.holes)) return null;

        const foundHole = scoringCourse.holes.find((hole) => hole.id.toString() === holeId);

        return foundHole || null;
    }

    getHardestHole() {
        const { holeId, scoringStats, scoringPlayer } = this.props;

        if (!scoringStats || !Array.isArray(scoringStats.rounds)) return null;

        return getHardestHole(
            getRoundById(scoringStats.rounds, scoringPlayer.currentRound),
            holeId
        );
    }

    getScores() {
        const { scoringPlayer, scoringCourse, scoringStats } = this.props;

        if (!scoringPlayer ||
            !scoringCourse ||
            !scoringStats ||
            ArrayHelper.isEmpty(scoringPlayer.rounds) ||
            ArrayHelper.isEmpty(scoringCourse.holes)
        ) return [];

        const previousRoundsIds = getPreviousRoundsIds(scoringPlayer.currentRound);

        return previousRoundsIds.map((previousRoundId) => {
            const playerRound = getRoundById(scoringPlayer.rounds, previousRoundId);
            const courseRound = getRoundById(scoringCourse.courseRounds, previousRoundId);

            if (!courseRound ||
                !courseRound.holePars ||
                !playerRound ||
                ArrayHelper.isEmpty(playerRound.info)
            ) {
                return null;
            }

            const foundHole = courseRound.holePars.find((hole) =>
                hole.holeId.toString() === this.props.holeId.toString());
            const scoresInfo = playerRound.info.find((infoItem) =>
                infoItem.holeId.toString() === scoringPlayer.hole.toString());

            if (!scoresInfo) return null;

            return {
                roundId: previousRoundId,
                holePar: foundHole && foundHole.par,
                playerPar: scoresInfo.playerPar
            };
        }).filter((previousRound) => previousRound !== null);
    }

    render() {
        const { holeId } = this.props;
        const hole = this.getHole();
        const scores = this.getScores();
        const hardestHole = this.getHardestHole();

        if (!hole) return null;

        const { sitecoreData } = hole;

        return (
            <div className="live-player-location">
                <div className="live-player-location__bg of-cover">
                    <img src={sitecoreData.greenSrc} alt="" />
                </div>
                <div className="live-player-location__body">
                    <div className="live-player-location__info">
                        <div className="live-player-location__hole-flag">
                            {
                                IS_HOLECARD_AVAILABLE ?
                                <button
                                    className="hole-flag"
                                    type="button"
                                    onClick={() => liveHole.show(Number(holeId))}
                                >{sitecoreData.holeNumber}</button>
                                :
                                <button
                                    className="hole-flag not-interactive"
                                    type="button"
                                >{sitecoreData.holeNumber}</button>
                            }

                            
                        </div>

                        <div>
                            <div className="live-player-location__info-top">
                                <span className="live-player-location__info-item">Par&nbsp;<b>{hole.par}</b></span>
                            </div>
                            <div className="live-player-location__info-bottom live-copy">
                                <span className="live-player-location__info-item">
                                    Yardage&nbsp;<b>{sitecoreData.holeYardage || 0}</b>
                                </span>
                                {
                                    hardestHole &&
                                    <span className="live-player-location__info-item">{hardestHole}</span>
                                }                                
                            </div>
                        </div>
                    </div>
                    {
                        scores.length > 0 &&
                        <div className="live-player-location__scores">
                            <div className="live-player-location__scores-label live-copy">
                                <span className="live-player-location__scores-label-long">Previous scores</span>
                                <span className="live-player-location__scores-label-short">Previous</span>
                            </div>
                            {
                                scores.map((score) => (
                                    <div key={score.roundId} className="live-player-location__score">
                                        <div className="live-player-location__score-label">R{score.roundId}</div>
                                        <ScorePlayerCell holePar={score.holePar} playerPar={score.playerPar} />
                                    </div>
                                ))
                            }
                        </div>
                    }
                </div>
            </div>
        );
    }
}

LivePlayerLocation.propTypes = {
    holeId: PropTypes.string,
    scoringPlayer: PropTypes.object,
    scoringCourse: PropTypes.object,
};

export default LivePlayerLocation;
